import { z } from 'zod'

const fullNameSegments = (value: string) =>
  value
    .trim()
    .split(/\s+/)
    .filter(s => s.length > 0)

export const scholarshipApplicationSchemaZ = z.object({
  fullName: z
    .string()
    .trim()
    .min(1, { message: 'Podaj imię i nazwisko' })
    .max(160, { message: 'Maksymalnie 160 znaków' })
    .refine(v => fullNameSegments(v).length >= 2, {
      message: 'Podaj imię i nazwisko (imię oraz nazwisko)'
    }),
  email: z.string().trim().email({ message: 'Podaj poprawny adres email' }),
  phone: z
    .string()
    .trim()
    .max(30)
    .refine(v => v === '' || /^\+?[0-9 \-()]{6,20}$/.test(v), 'Niepoprawny numer telefonu'),
  message: z.string().trim().max(4000, { message: 'Maksymalnie 4000 znaków' }),
  consentContact: z.boolean().refine(v => v === true, {
    message: 'Aby przesłać wniosek, potrzebujemy zgody na kontakt w sprawie stypendium'
  }),
  consentMarketingOffers: z.boolean()
})

export type ScholarshipApplicationFormData = z.infer<typeof scholarshipApplicationSchemaZ>

export const scholarshipApplicationDefaultValues: ScholarshipApplicationFormData = {
  fullName: '',
  email: '',
  phone: '',
  message: '',
  consentContact: false,
  consentMarketingOffers: false
}
